import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AgentDashboardView } from "./agentDashboardView";
import { LoadingAFY, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import React from "react";
export var AgentDashboard = function () {
    var _a = React.useState(false), loading = _a[0], setLoading = _a[1];
    return (_jsxs(_Fragment, { children: [_jsx(LoadingAFY, { loading: loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(AgentDashboardView, {})] }));
};
